import { Card, Col } from "reactstrap";
import { dynamicImage } from "../../../../../utils";
import InfoSection from "./InfoSection";
import SocialMediaAndFollow from "./SocialMediaAndFollow";
import { Image } from "../../../../../coreComponents/Image";
import { useAppSelector } from "../../../../../reduxToolkit/hooks";

const Profile = () => {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const { name, email } = useAppSelector((state) => state.auth);

  return (
    <Col sm="12">
      <Card className="hovercard text-center">
        <div className="cardheader"></div>
        <div className="user-image">
          <div className="avatar">
            <Image src={dynamicImage(`user/7.jpg`)} alt="user" />
          </div>
          <div className="icon-wrapper">
            <i className="icofont icofont-pencil-alt-5"></i>
          </div>
        </div>
        <div className="info">
          {isAuthenticated && name && email && (
            <InfoSection name={name} email={email} />
          )}
          <hr />
          {/* <SocialMediaAndFollow /> */}
        </div>
      </Card>
    </Col>
  );
};

export default Profile;
